module.exports = __webpack_public_path__ + "static/media/questions-circular.5d2e5e0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/questions-circular.svg
// module id = 774
// module chunks = 0